.root {
  display: grid;
  grid-template-rows: min-content minmax(0, 1fr) min-content;
  grid-template-columns: repeat(12, 1fr);
  row-gap: 1.5rem;
  column-gap: 2.5rem;

  @media (--sm-down) {
    column-gap: 1rem;
  }
}

.full {
  grid-column-end: span 12;
}

.half {
  grid-column-end: span 6;

  @media (max-width: 1300px) {
    grid-column-end: span 12;
  }
}

.twoThirds {
  grid-column-end: span 8;

  @media (--md-down) {
    grid-column-end: span 12;
  }
}

.oneThird {
  grid-column-end: span 4;

  @media (--md-down) {
    grid-column-end: span 12;
  }
}

.sevenTwelfths {
  grid-column-end: span 7;

  @media (--md-down) {
    grid-column-end: span 12;
  }
}

.fiveTwelfths {
  grid-column-end: span 5;

  @media (--md-down) {
    grid-column-end: span 12;
  }
}
